<template>
  <table class="lyTableBlack">
    <thead>
      <tr>
        <td
          :style="{ width: x.width ? x.width + 'px' : '' }"
          v-for="(x, index) in columns"
          :key="index"
        >
          <template v-if="x.title">{{ x.title }}</template>
          <template v-else>#</template>
        </td>
      </tr>
    </thead>
    <tbody class="gundongtiao gundongtiao1">
      <tr v-for="(y, index1) in tableData" :key="index1">
        <td
          :style="{ width: x.width ? x.width + 'px' : '' }"
          v-for="(x, index) in columns"
          :key="index"
        >
          <template v-if="x.type == 'index'">{{ index1 + 1 }}</template>
          <template v-if="x.key">{{ y[x.key] }}</template
          ><slot
            v-if="x.slot"
            :name="x.slot"
            :row="tableData[index1]"
            :index="index1"
          ></slot>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: ["tableData", "columns"],
  data() {
    return {};
  },
  methods: {},
};
</script>
<style>
.lyTableBlack {
  padding: 10px;
  height: calc(100% - 40px);
  margin-bottom: 20px;
  border: solid #086486;
  border-width: 4px 0;
}
.lyTableBlack tr {
  width: 100%;
}
.lyTableBlack th {
  line-height: 3;
}

.lyTableBlack td {
  padding: 6px 4px;
  text-align: left;
}

.lyTableBlack thead,
.lyTableBlack tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.lyTableBlack thead {
  width: calc(100% - 1em);
}
.lyTableBlack tbody {
  display: block;
  height: calc(100% - 32px);
  overflow-y: auto;
  border-top: solid 1px #1a65a2;
  padding-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/lytable.vue